<template>
    <div class="col-md-12">
        <div class="modal-body">
            <span v-html="soifromdb"></span>
        </div>

        <div class="modal-footer">
            <button type="button"
                    @click="getfile()"
                    class="btn btn-success">
                Download
            </button>
        </div>

    </div>
</template>
<script>
    import {
        authHeader,
        RecordURL,
        responseCheck,
        downloadblob
    } from "../../helper/index";
    import instance from "../../helper/http";
    export default {

        data() {
            return {
                id: "",
                soifromdb: ""
            };
        },
        props: {
            Id: {
                type: String,
                required: true,
            },
            html: {
                type: String,
                required: true,
            }
        },
        created: function () {
            this.id = this.Id
            this.soifromdb = this.html
        },
        methods: {
            download: function (docID, filename, type) {
                //window.open(RecordURL + 'downloadcopy?docID=' + docID, '_blank', '')
                instance
                    .get(RecordURL + "downloadcopy?docID=" + docID, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(filename, response.data, type);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getfile() {
                instance
                    .get(RecordURL + "checkfiles?docID=" + this.id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withfiles) {
                            this.download(this.id, response.data.filename, response.data.type);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            }
        },
    };
</script>